var map = {
	"./angular.svg": "9451",
	"./apple-safari.png": "4f49",
	"./b1.png": "a731",
	"./b2.png": "e7ff",
	"./b3.png": "7554",
	"./banking-and-accounting.png": "5ac3",
	"./book.svg": "a337",
	"./bootstrap.svg": "2ea3",
	"./brush.svg": "815f",
	"./bulb.png": "418e",
	"./business-share-holder-management.png": "7955",
	"./doc.png": "493f",
	"./drive.png": "8f4a",
	"./dropbox.png": "0e4f",
	"./figma.svg": "7472",
	"./file-icons/doc.png": "61d5",
	"./file-icons/onedrive.png": "37bc",
	"./file-icons/pdf.png": "a235",
	"./file-icons/psd.png": "051b",
	"./file-icons/sketch.png": "2863",
	"./fly.png": "2c96",
	"./google-chrome.png": "d8dc",
	"./icloud-1.png": "e4ab",
	"./icloud.png": "9431",
	"./internet-explorer.png": "d7bc",
	"./internet.png": "beef",
	"./job-portal-solution.png": "2eea",
	"./jpg.png": "1568",
	"./js.png": "2710",
	"./json.png": "0ec4",
	"./light-bulb.png": "5075",
	"./location-dot-solid.svg": "0e6c",
	"./mozila-firefox.png": "9fa4",
	"./onedrive.png": "8250",
	"./onedrivenew.png": "efb5",
	"./opera.png": "2fad",
	"./parachute.svg": "666b",
	"./pdf.png": "f35f",
	"./phone-solid.svg": "a4a6",
	"./psd.png": "3a95",
	"./react.svg": "f4d6",
	"./rocket.svg": "df02",
	"./sketch.png": "c62d",
	"./speaker.svg": "1535",
	"./star.svg": "0a83",
	"./toolbox.svg": "40d5c",
	"./txt.png": "d36d",
	"./unknown.png": "91ed",
	"./vuejs.svg": "57c1",
	"./workspace-management.png": "dc1c",
	"./xls.png": "d75a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";